/// <amd-module name="Test/FailedTestsMetricView/Interfaces" />
export interface IFailedTestsMetricViewData {
    count?: number;
}
